import { type FunctionalComponent, h } from '@stencil/core';
import { imagePlaceholder } from '../../../variables';

interface SectionLoaderWrapperProps {
  contentReady?: boolean;
  fullWidth?: boolean;
  minHeight: number;
  noContent?: boolean;
  hasSection?: boolean;
  picturePlaceholder?: boolean;
}

const calculateSkeletonContainers = (minHeight: number, containerHeight: number): number =>
  Math.ceil(minHeight / containerHeight);

const renderSkeleton = (minHeight: number, skeletonCount: number, picturePlaceholder: boolean) =>
  minHeight < 300 ? (
    <div class="search-skeleton-container">
      <div class="search-skeleton">
        <div class="search-skeleton__item"></div>
        <div class="search-skeleton__item"></div>
        <div class="search-skeleton__item"></div>
      </div>
    </div>
  ) : (
    [...Array(skeletonCount)].map(() => (
      <div class="search-skeleton-container">
        {picturePlaceholder && <img src={imagePlaceholder} width={100} height={100} alt="image placeholder" />}
        <div class="search-skeleton">
          <div class="search-skeleton__item"></div>
          <div class="search-skeleton__item"></div>
          <div class="search-skeleton__item"></div>
          <div class="search-skeleton__item"></div>
        </div>
      </div>
    ))
  );

export const SectionLoaderWrapper: FunctionalComponent<SectionLoaderWrapperProps> = (
  { hasSection = true,
    noContent = false,
    fullWidth = false,
    minHeight,
    contentReady = true,
    picturePlaceholder = false }, children) => {
    const skeletonCount = calculateSkeletonContainers(minHeight, 300);

    return hasSection ? (
      <div class={{ 'skeleton': true, 'full-w-block': fullWidth }} style={{ minHeight: noContent ? '0px' : `${minHeight}px` }}>
        {!contentReady && renderSkeleton(minHeight, skeletonCount, picturePlaceholder)}
        <uiaas-section-loader content={noContent ? null : children} content-ready={contentReady} />
      </div>
    ) : '';
};
